import en from './en';
import ru from './ru';

import cards from './cards/';
import dialogs from './dialogs/';
import score from './score/';

import admin from './admin/';
import administration from './administration/';
import board from './board/';
import company from './company/';
import companyFeed from './company-feed/';
import curator from './curator/';
import dashboard from './dashboard/';
import documents from './documents/';
import meetings from './meetings/';
import profile from './profile/';
import progress from './progress/';
import report from './report/';
import resume from './resume/';
import roadmap from './roadmap/';
import survey from './survey/';
import targets from './targets/';
import team from './team/';
import testing from './testing';

const messages = {
  en: {
    ...en,
    ...cards.en,
    ...dialogs.en,
    ...score.en, // common -> score
    // pages
    ...admin.en,
    ...administration.en,
    ...board.en,
    ...company.en,
    ...companyFeed.en,
    ...curator.en,
    ...dashboard.en,
    ...documents.en,
    ...meetings.en,
    ...profile.en,
    ...progress.en,
    ...report.en,
    ...resume.en,
    ...roadmap.en,
    ...survey.en,
    ...targets.en,
    ...team.en,
    ...testing.en,
  },
  ru: {
    ...ru,
    ...cards.ru,
    ...dialogs.ru,
    ...score.ru, // common -> score
    // pages
    ...admin.ru,
    ...administration.ru,
    ...board.ru,
    ...company.ru,
    ...companyFeed.ru,
    ...curator.ru,
    ...dashboard.ru,
    ...documents.ru,
    ...meetings.ru,
    ...profile.ru,
    ...progress.ru,
    ...report.ru,
    ...resume.ru,
    ...roadmap.ru,
    ...survey.ru,
    ...targets.ru,
    ...team.ru,
    ...testing.ru,
  },
};
/* Ключи в компонентах приоритетны. Если там записи нет а здесь есть -
   будет сообщение отсюда, иначе из компонента */
export default messages;
